export default {
	defaultObject() {
		return {};
	},
};
